<template>
  <ZMainPage :loading="loading" type="card">
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text">基础信息</span>
      </div>
      <LineWrapper column="3" label-width="170rem" list>
        <LineItem v-for="item in list" :key="item.label" :label="item.label">
          <span v-if="item.value" class="mr-1">{{ item.value }}</span>
          <span v-if="item.button" class="text-primary c-p" @click="handlePreview(item.type)">{{ item.button }}</span>
        </LineItem>
        <image-viewer :list="[score_image]" :visible.sync="visible"/>
      </LineWrapper>
    </div>
    <div class="z-box-bg mb-2">
      <div class="z-box-title">
        <span class="z-box-title-text mr-2">缴费详情</span>
        <template v-if="diff_fee_tag.length">
          <ZuTips v-for="(item, idx) in diff_fee_tag" v-if="item.name" :key="idx" :type="item.type === 1 ? pay_status === 1 ? 'green' : 'red' : 'orange'" :value="item.name"/>
        </template>
      </div>
      <el-form ref="form" :model="formData" :rules="rules" label-position="left" label-width="200rem">
        <el-row>
          <el-col span="8">
            <el-form-item label="系统计算应缴总额" style="margin-left: 12rem">
              {{ money_answer }}
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="是否缴费" prop="is_pay">
              <el-select v-model="formData.is_pay" placeholder="请选择是否缴费">
                <el-option :value="1" label="是"></el-option>
                <el-option :value="2" label="否"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="formData.is_pay===1" span="8">
            <el-form-item label="是否分期" prop="is_by_stages">
              <el-select v-model="formData.is_by_stages" placeholder="请选择是否分期" @change="onStageChange">
                <el-option :value="0" label="否"></el-option>
                <!-- <el-option :value="1" label="是"></el-option> -->
                <el-option :value="2" label="部分欠缴"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <template v-if="formData.is_pay===2">
          <el-form-item style="margin-bottom: 0;"></el-form-item>
          <el-form-item label="驳回原因" prop="reason">
            <el-input v-model="formData.reason" maxlength="300" placeholder="请输入驳回原因" rows="8" show-word-limit style="width: 790rem" type="textarea"></el-input>
            <div>
              <div class="tips-info">
                <i class="el-icon-warning z-i"></i>
                <span>驳回后，家长端订单将自动取消，请谨慎操作!</span>
              </div>
            </div>
          </el-form-item>
        </template>
        <template v-else>
          <template v-if="formData.is_by_stages===2">
            <el-form-item label="本期实缴总额" prop="show_price">
              <el-input v-model="formData.show_price" placeholder="请输入学生缴费金额" @input="onPriceChange"></el-input>
            </el-form-item>
          </template>
          <div class="table-wrap">
            <template v-if="formData.is_by_stages===0">
              <zu-special-table ref="t0" :config="config" is-edit-disable :data="data" @change="onChange"/>
            </template>
            <template v-else-if="formData.is_by_stages===2">
              <zu-special-table  ref="t2" :config="config" is-edit-disable :count="formData.show_price" :data="data" is-part @change="onChange"/>
            </template>
          </div>
          <el-row>
            <el-col span="8">
              <el-form-item :label="formData.is_by_stages ? '合计实际应缴总额' : '合计实缴总额'">
                <div>
                  {{ formData.sum_price }}
                </div>
                <template v-if="interestAmount.isShow && !formData.is_by_stages">
                  <div>
                    <ZuTips show-icon type="red">学生合计应缴总额：{{ interestAmount.sum }}</ZuTips>
                  </div>
                  <div>
                    <ZuTips show-icon type="red">累计利息减免总额：{{ interestAmount.amount }}</ZuTips>
                  </div>
                </template>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item label="合计特批优惠总额">
                {{ formData.sum_discount_price }}
              </el-form-item>
            </el-col>
          </el-row>
          <template v-if="formData.is_by_stages">
            <el-row>
              <el-col span="8">
                <el-form-item label="合计本期实缴总额">
                  {{ formData.sum_first_price }}
                  <template v-if="interestAmount.isShow && formData.is_by_stages">
                    <div>
                      <ZuTips show-icon type="red">学生合计本期应缴总额：{{ interestAmount.sum }}</ZuTips>
                    </div>
                    <div>
                      <ZuTips show-icon type="red">累计利息减免总额：{{ interestAmount.amount }}</ZuTips>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
              <el-col span="8">
                <el-form-item label="合计欠缴总额">
                  {{ formData.sum_remain_price }}
                </el-form-item>
              </el-col>
            </el-row>
          </template>
          <el-row>
            <el-col span="8">
              <el-form-item v-if="formData.is_by_stages" label="是否发起分期钉钉审批" prop="is_stages_dingtalk_approve">
                <el-select v-model="formData.is_stages_dingtalk_approve" placeholder="请选择是否发起分期钉钉审批">
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item v-if="formData.sum_discount_price" label="是否发起特批优惠钉钉审批" prop="is_discount_dingtalk_approve">
                <el-select v-model="formData.is_discount_dingtalk_approve" placeholder="请选择是否发起特批优惠钉钉审批">
                  <el-option :value="1" label="是"></el-option>
                  <el-option :value="0" label="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col span="8">
              <el-form-item v-if="formData.sum_discount_price && formData.is_discount_dingtalk_approve === 1" label="特批优惠减免类型" prop="discount_amount_type">
                <el-select v-model="formData.discount_amount_type" placeholder="请选择特批优惠减免类型">
                  <el-option :value="1" label="政策内减免"></el-option>
                  <el-option :value="2" label="政策外减免"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item v-if="showMethod" class="z-no-margin-bottom mb-2" label="实缴金额及方式">
            <div v-for="(domain, index) in formData.payment_detail" :key="domain.id" class="z-dynamic-list-item">
              <div class="flex z-dynamic-list-inner">
                <el-form-item :prop="`payment_detail.${index}.paid_amount`" :rules="dynamicNumber" labelWidth="0">
                  <el-input v-model="domain.paid_amount" placeholder="请输入学生缴费金额" @input="onAmountChange($event, index, domain.payment_method === '银行垫资')"></el-input>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item :prop="`payment_detail.${index}.payment_method`" :rules="dynamicSelect" labelWidth="0">
                  <el-select v-model="domain.payment_method" placeholder="请选择学生缴费方式" @change="onMethodChange($event, index)">
                    <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <div v-if="domain.payment_method === '银行垫资'">
                    <ZuTips show-icon type="red">
                      <span>利息减免金额：</span>
                      <span :contenteditable="formData.interest_amount_is_can_chg ? true : false" @blur="onInterestChang($event, index)">{{ domain.interest_amount }}</span>
                    </ZuTips>
                  </div>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item :prop="`payment_detail.${index}.payer`" :rules="dynamicInput" labelWidth="0">
                  <el-input v-model="domain.payer" maxlength="20" placeholder="请输入付款人姓名"></el-input>
                </el-form-item>
                <div class="px-2 text-gray">-</div>
                <el-form-item :prop="`payment_detail.${index}.payment_at`" :rules="dynamicData" labelWidth="0">
                  <el-date-picker v-model="domain.payment_at" placeholder="请选择缴费时间" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                </el-form-item>
              </div>
              <el-form-item label-width="40rem">
                <el-button v-if="formData.payment_detail.length !== 1" circle icon="el-icon-delete" @click.prevent="handelRemove(domain)"></el-button>
                <el-button v-if="formData.payment_detail.length !== dynamicMaxlength && index === formData.payment_detail.length - 1" circle icon="el-icon-plus" @click="handleAdd"></el-button>
              </el-form-item>
            </div>
            <div class="tips-info">
              <i class="el-icon-warning z-i"></i>
              <span>{{ sumAmount }}</span>
            </div>
          </el-form-item>
          <el-form-item v-if="interestAmount.isShow" label="三年学费预计应缴总额">
            {{ totalFee }}
          </el-form-item>
          <el-row>
            <el-col span="15">
              <el-form-item label="备注">
                <el-input v-model="formData.remark" maxlength="300" placeholder="请输入" rows="8" show-word-limit type="textarea"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-form>
    </div>
    <Dialog :showFooter="false" :title="title" :visible.sync="dialogVisible1" size="big">
      <template v-if="dialogType === 1">
        <LineWrapper column="3" list>
          <LineItem v-for="item in dialogList" :key="item.label" :label="item.label" :value="item.value"></LineItem>
        </LineWrapper>
        <div class="pb-2"></div>
        <CustomTable :config="dialogListConfig1" :data="dialogListData1" :radius="false" headerBgColor="#CBE4FF" headerColor="#333" titleBgColor="#CBE4FF"></CustomTable>
        <CustomTable v-if="dialogListData2.length" :config="dialogListConfig2" :data="dialogListData2" :radius="false" headerBgColor="#CBE4FF" headerColor="#333" titleBgColor="#CBE4FF"></CustomTable>
      </template>
      <template v-else-if="dialogType === 2">
        <CustomTable :config="dialogConfig" :data="dialogData" border></CustomTable>
      </template>
    </Dialog>
    <template slot="footer">
      <template v-if="formData.is_pay !== 2">
        <el-button type="primary" @click="onClick('form')">通过</el-button>
        <el-button type="warning" @click="onClick('form', false)">暂存</el-button>
      </template>
      <el-button v-if="formData.is_pay!==1" type="primary" @click="onClick('form')">驳回</el-button>
      <el-button @click="$router.back()">返回</el-button>
    </template>

    <el-dialog :before-close="handleClose" :close-on-click-modal="false" :visible.sync="dialogVisible" width="30%">
      <div style="text-align: center;margin-top: 12rem;font-weight: 700;font-size: 18rem">
        {{ formData.is_pay === 1 ? '是否确认学生缴费完成并通过审批 ?' : '驳回后家长端订单将自动取消，是否确认驳回?' }}
      </div>
      <div slot="footer" style="width: 100%;display: flex;justify-content: space-between;padding: 12rem 128rem">
        <el-button type="primary" @click="onCm">确 定</el-button>
        <el-button @click="dialogVisible = false">再看看</el-button>
      </div>
    </el-dialog>
  </ZMainPage>
</template>

<script>
import LineWrapper from '@/components/common/LineWrapper'
import LineItem from '@/components/common/LineItem'
import ImageViewer from '@/components/common/ImageViewer'
import Dialog from '@/components/common/Dialog'
import ZuSpecialTable from "./components/ZuSpecialTable"
import CustomTable from "@/components/common/CustomTable"
import ZuTips from "@/components/common/ZuTips"
import http from '@/api'
import {validateNumber} from '@/utils/validate'
import {objectIsEmpty, preciseAdd, preciseSubtract, formatDate} from '@/utils'
import {orderPayMethod} from '@/utils/data'

export default {
  _config: {"route": {"path": "edit-2026", "meta": {"title": "审批"}}},
  components: {LineWrapper, LineItem, ImageViewer, Dialog, ZuSpecialTable, CustomTable, ZuTips},
  data() {
    const v1 = (_r, value, callback) => {
      if (value === '') return callback(new Error('请输入学生缴费金额'))
      const num1 = Number(this.money_answer)
      const num2 = Number(value)
      if (num2 > num1) return callback(new Error('本期实缴总额需小于系统计算应缴总额'))
      validateNumber(value, callback, {min: 0, max: num1, equalToMin: true, equalToMax: false})
    }
    return {
      loading: false,
      visible: false,
      dialogVisible1: false,
      student_name: '',
      dialogList: [],
      dialogType: '',
      dialogListData1: [],
      dialogListData2: [],
      dialogListConfig1: [],
      dialogListConfig2: [],
      dialogData: [],
      dialogConfig: [],
      diff_fee_tag: [],
      pay_status: '',
      money_answer: 0,
      order_id: '',
      senior_two_cost: 0,
      senior_three_cost: 0,
      sum_price: 0,
      sum_first_price: 0,
      formData: {
        interest_rate: '',
        interest_months: '',
        interest_amount_is_can_chg: 0,
        senior_two_cost: '',
        senior_three_cost: '',
        is_pay: 1,
        is_by_stages: 0,
        is_stages_dingtalk_approve: 0,
        is_discount_dingtalk_approve: 1,
        discount_amount_type: '',
        show_price: '',
        payment_detail: [],
        goods_stages: [],
        reason: '',
        remark: '',
        sum_compute_price: '',
        sum_discount_price: '',
        sum_first_price: '',
        sum_remain_price: '',
        sum_price: ''
      },
      loading: false,
      dialogVisible: false,
      rules: {
        is_pay: [{required: true, message: '请选择是否缴费', trigger: 'change'}],
        is_by_stages: [{required: true, message: '请选择是否分期', trigger: 'change'}],
        reason: [{required: true, message: '请输入驳回原因', trigger: 'blur'}],
        discount_amount_type: [{required: true, message: '请选择特批优惠减免类型', trigger: 'change'}],
        show_price: [{required: true, validator: v1, trigger: 'blur'}],
      },
      data: [],
      config: [],
      list: [],
      score_image: '',
      typeOptions: [],
      dynamicMaxlength: 15,
      dynamicSelect: {required: true, message: '请选择学生缴费方式', trigger: 'change'},
      dynamicInput: {required: true, message: '请输入付款人姓名', trigger: 'blur'},
      dynamicData: {required: true, message: '请选择缴费时间', trigger: 'blur'},
      dynamicNumber: {required: true, validator: (_, value, callback) => validateNumber(value, callback, {min: 0, equalToMin: true, empty: '请输入学生缴费金额'}), trigger: 'blur'},
    }
  },
  computed: {
    showMethod() {
      if (this.formData.is_by_stages && this.formData.show_price !== '') {
        if (Number(this.formData.show_price) === 0) return false
      }
      return true
    },
    sumAmount() {
      const arr = this.formData.payment_detail.filter(i => i.paid_amount)
      const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount) || 0), 0)
      if (isNaN(sum)) {
        return '请输入数字'
      }
      return `累计实缴金额：${sum}`
    },
    interestAmount() {
      const obj = {sum: 0, amount: 0, isShow: false}
      const data = JSON.parse(JSON.stringify(this.formData.payment_detail))
      const arr = data.filter(i => i.interest_amount)
      const s1 = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.interest_amount) || 0), 0)
      const hasVal = data.some(i => i.payment_method === '银行垫资')
      if (hasVal) {
        obj.isShow = true
      }
      obj.amount = s1
      if (isNaN(s1)) {
        obj.amount = 0
        this.formData.sum_price = this.sum_price
        this.formData.sum_first_price = this.sum_first_price
        return
      }
      if (this.formData.is_by_stages) {
        this.formData.sum_first_price = preciseSubtract(this.sum_first_price, s1)
        this.formData.sum_price = preciseSubtract(this.sum_price, s1)
        obj.sum = this.sum_first_price
      } else {
        this.formData.sum_price = preciseSubtract(this.sum_price, s1)
        obj.sum = this.sum_price
      }
      return obj
    },
    totalFee() {
      const arr = this.formData.goods_stages
      let s1 = this.sum_price || 0
      s1 = preciseSubtract(s1, this.interestAmount.amount)
      const arr2 = {1: 0, 2: 0, 3: 0}
      arr.forEach(i => {
        if (i.discount_year) {
          const val = arr2[i.discount_year]
          arr2[i.discount_year] = preciseAdd(i.discount_price, val)
        }
      })
      const y2 = preciseAdd(arr2[2], arr2[3])
      let s2 = preciseSubtract(this.senior_two_cost, y2)
      let s3 = preciseSubtract(this.senior_three_cost, arr2[3])
      s1 = s1 >= 0 ? s1 : 0
      s2 = s2 >= 0 ? s2 : 0
      s3 = s3 >= 0 ? s3 : 0
      const s4 = preciseAdd(s1, preciseAdd(s2, s3))
      this.formData.senior_two_cost = s2
      this.formData.senior_three_cost = s3
      return s4
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    handlePreview(type) {
      if (type === 0) {
        this.visible = true
      } else {
        const arr = {
          1: '最高诊断性考试成绩详情',
          2: '预报名订单',
          3: `${this.student_name}的缴费计划`
        }
        this.title = arr[type]
        this.dialogVisible1 = true
        this.dialogType = type
      }
    },
    getConfig() {
      this.typeOptions = orderPayMethod()
    },
    onStageChange() {
      this.formData.show_price = ''
      this.getConfig()
      this.getStages()
    },
    onPriceChange(e) {
      if (isNaN(Number(e))) return
      if (this.money_answer <= this.formData.show_price) return
      this.formData.sum_first_price = Number(e)
      this.formData.sum_remain_price = preciseSubtract(this.formData.sum_price, this.formData.sum_first_price)
      this.handleClear()
    },
    onChange(e) {
      // sum_price 实缴总额
      // sum_discount_price 合计特批优惠总额
      // sum_first_price 合计本期实缴总额
      // sum_remain_price 合计欠缴总额
      this.sum_price = e.sum_price
      this.sum_first_price = e.sum_first_price
      this.formData.sum_price = e.sum_price
      this.formData.sum_discount_price = e.sum_discount_price
      this.formData.sum_first_price = e.sum_first_price
      this.formData.sum_remain_price = e.sum_remain_price
      this.formData.goods_stages = e.goods_stages
      this.handleClear()
    },
    handleClear() {
      this.formData.payment_detail = []
      this.handleAdd()
    },
    handleAdd() {
      if (this.dynamicMaxlength <= this.formData.payment_detail.length) {
        return this.$message.warning(`最多只能添加${this.dynamicMaxlength}条`);
      }
      this.formData.payment_detail.push({id: Date.now(), payment_method: '', paid_amount: '', payer: '', interest_amount: 0, interest_rate_detail: [], payment_at: formatDate().fullDateTime, isAdd: 1})
    },
    handleDelete(item) {
      const index = this.formData.payment_detail.indexOf(item)
      if (!~index) return
      this.formData.payment_detail.splice(index, 1)
    },
    handelRemove(item) {
      const {id, ...other} = item
      if (objectIsEmpty(other, ['isAdd'])) return this.handleDelete(item)
      this.$confirm('此操作将删除该项, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, _instance, done) => {
          if (action === 'confirm') this.handleDelete(item)
          done()
        }
      }).then(() => {
        this.$message({type: 'success', message: `删除成功!`})
      })
    },
    onMethodChange(e, idx) {
      if (e === '银行垫资') {
        const val = this.formData.payment_detail[idx].paid_amount
        this.onAmountChange(val, idx)
      } else {
        this.formData.payment_detail[idx].interest_amount = 0
        this.formData.payment_detail[idx].interest_rate_detail = []
      }
    },
    onAmountChange(e, idx) {
      const isTypeRight = this.formData.payment_detail[idx].payment_method === '银行垫资'
      if (!isTypeRight) return
      const val = Number(e)
      if (isNaN(val) || val === 0) {
        this.formData.payment_detail[idx].interest_amount = 0
        this.formData.payment_detail[idx].interest_rate_detail = []
        return
      }
      this.getRate(val, idx)
    },
    onInterestChang(e, idx) {
      const v = Number(e.target.innerText) || 0
      this.formData.payment_detail[idx].interest_amount = v
    },
    getRate(amount_total, idx) {
      const data = {amount_total, interest_rate: this.formData.interest_rate, interest_months: this.formData.interest_months}
      http({url: '/recruit-v2/order-offline/get-rate-compute-details', pre: 'zs'}, data).then(res => {
        const {interest_amount, interest_rate_detail} = res
        const obj = this.formData.payment_detail[idx]
        obj.interest_amount = interest_amount
        obj.interest_rate_detail = interest_rate_detail
        this.formData.payment_detail.splice(idx, 1, obj)
      })
    },
    getStages() {
      this.data = []
      this.config = []
      http({url: '/recruit-v2/order-offline/get-goods-stages-v2', pre: 'zs'}, {order_id: this.order_id, is_by_stages: this.formData.is_by_stages}).then(res => {
        const {goods_stages, interest_rate, interest_months, interest_amount_is_can_chg = 0, senior_two_cost, senior_three_cost, is_cache_data, payment_detail = []} = res
        this.formData.interest_rate = interest_rate
        this.formData.interest_months = interest_months
        this.formData.interest_amount_is_can_chg = interest_amount_is_can_chg
        const v2 = Number(senior_two_cost), v3 = Number(senior_three_cost)
        this.formData.senior_two_cost = v2
        this.formData.senior_three_cost = v3
        this.senior_two_cost = v2
        this.senior_three_cost = v3

        if (is_cache_data) {
          const id = Date.now()
          const arr = payment_detail.map((i, j) => ({...i, id: id + j, paid_amount: Number(i.paid_amount)}))
          this.formData.is_pay = res.is_pay
          // this.formData.is_by_stages = res.is_by_stages
          this.formData.is_stages_dingtalk_approve = res.is_stages_dingtalk_approve ?? 0
          this.formData.is_discount_dingtalk_approve = res.is_discount_dingtalk_approve ?? 1
          this.formData.discount_amount_type = res.discount_amount_type
          this.formData.payment_at = res.payment_at
  
          if (this.formData.is_by_stages === 2) {
            this.formData.show_price = res.sum_first_price
          }
          if (res.is_pay) {
            this.formData.remark = res.reason
          } else {
            this.formData.reason = res.reason
          }
          setTimeout(() => {
            this.formData.payment_detail = arr
          }, 500);
        } else {
          this.handleAdd()
        }
        let options2 = [{label: '享受当年优惠', value: 1}, {label: '享受两年优惠', value: 2}, {label: '享受三年优惠', value: 3}]
        const list = goods_stages.map((i) => {
          const {stages_mode_select = [], ...j} = i
          let options = []
          if (stages_mode_select.length) {
            options = stages_mode_select.map((k) => {
              return {
                label: Object.values(k)[0],
                value: Object.keys(k)[0]
              }
            })
          }
          return {
            ...j,
            isShow: stages_mode_select.length > 0,
            stages_mode_select,
            options,
            discount_year: Number(i.discount_year) || '',
            discount_price: Number(i.discount_price),
            compute_price: Number(i.compute_price),
            price: Number(i.price),
            first_price: Number(i.first_price),
            average_price: Number(i.average_price) || ''
          }
        })
        this.data = list
        if (this.formData.is_by_stages === 1) {
          this.config = [
            {label: '序号', type: 'index'},
            {prop: 'goods_category_name', label: '学费明细', type: 'text'},
            {prop: 'stages_mode', label: '缴费计划', type: 'select'},
            {prop: 'compute_price', label: '系统计算应缴金额', type: 'text'},
            {prop: 'discount_price', label: '特批优惠金额', type: 'input'},
            {prop: 'discount_year', label: '特批优惠年份', type: 'select', options: options2},
            {prop: 'price', label: '实际应缴金额', type: 'text'},
            {prop: 'first_price', label: '本期实缴金额', type: 'text'},
            {prop: 'average_price', label: '每期应缴金额', type: 'text'}
          ]
          return
        }
        this.config = [
          {label: ['缴费金额', '缴费项目'], type: 'title'},
          {prop: 'compute_price', label: '系统计算应缴金额', type: 'text'},
          {prop: 'discount_price', label: '特批优惠金额', type: 'input'},
          {prop: 'discount_year', label: '特批优惠年份', key: 'discount_year', type: 'select', options: options2}
        ]
      })
    },
    getData() {
      this.loading = true
      http({url: '/recruit-v2/order-offline/show?id=' + this.$route.query.id, pre: 'zs'}).then(res => {
        this.formData.is_by_stages = res.offline_is_by_stages || 0
        this.student_name = res.student_name
        this.formData.sum_compute_price = res.money_answer
        this.diff_fee_tag = res.tag || []
        this.pay_status = res.pay_status
        this.money_answer = res.money_answer
        this.score_image = res.score_image
        this.order_id = res.order_id

        this.getConfig()
        const list = [
          {label: '订单编号', value: res.order_number},
          {label: '入账学校', value: res.school},
          {label: '购买服务名称', value: res.goods_pack_name},

          {label: '学生姓名', value: res.student_name},
          {label: '学生身份证号/护照号', value: res.student_idcard},
          {label: '报名年级', value: res.grade_name},
          {label: '学习方向', value: res.study_type_name || '-'},
          {label: '专业方向', value: res.major_name || '-'},

          {label: '当前客户归属招生老师', value: res.belong_teacher}
        ]
        list.push({label: '是否参与预报名', value: res.is_pre_register, button: res.is_pre_register === '是' ? '查看详情' : '', type: 2})
        if (res.is_pre_register === '是') {
          list.push({label: '预报名支付金额', value: res.pre_register_amount})
        }
        if (res.order_type === 2) {
          if (res.max_score_name === '中考') {
            list.push({label: '中考成绩折算后总分', value: res.max_score})
            list.push({label: '中考成绩截图', value: res.score_image ? '' : '-', button: res.score_image ? '查看成绩截图' : '', type: 0})
          } else {
            list.push({label: '最高诊断性考试折算后总分', value: res.max_score, button: '查看详情', type: 1})
            this.dialogList = [
              {label: '学生姓名', value: res.student_name},
              {label: '学生参考城市', value: res.senior_city},
              {label: '考试名称', value: res.max_score_name},
              {label: '考试总分', value: res.junior_score},
              {label: '折算后考试总分', value: res.max_score}
            ]
            const {diagnose_score_list} = res
            const options = [], l1 = diagnose_score_list[0]?.length
            if (l1) {
              for (let i = 0; i < l1; i++) {
                options.push({label: diagnose_score_list[0][i], value: diagnose_score_list[1][i]})
              }
            }
            let l2 = options.length
            if (l2 > 3) {
              l2 = Math.ceil(l2 / 2)
            }
            const obj1 = {num: '分数'}, obj2 = {num: '分数'}, config1 = [{label: '科目', prop: 'num', type: 'title'}], config2 = [{label: '科目', prop: 'num', type: 'title'}]
            options.forEach((i, index) => {
              if (index < l2) {
                obj1[`k_${index}`] = i.value
                config1.push({prop: `k_${index}`, label: i.label})
              } else {
                obj2[`k_${index}`] = i.value
                config2.push({prop: `k_${index}`, label: i.label})
              }
            })
            this.dialogListData1 = [obj1]
            this.dialogListConfig1 = config1
            if (config2.length > 1) {
              const l3 = config1.length - config2.length
              if (l3 > 0) {
                for (let i = 0; i < l3; i++) {
                  config2.push({prop: `z_${i}`, label: ''})
                }
              }
              this.dialogListData2 = [obj2]
              this.dialogListConfig2 = config2
            }
          }
        }
        this.list = list
        const {pre_register = []} = res
        this.dialogData = pre_register.map(i => ({
          order_number: i.order_number,
          belong_teacher_name: i.belong_teacher_name,
          money_answer: i.money_answer,
          money_actual: i.money_actual,
          pay_time: i.pay_time || '-'
        }))
        this.dialogConfig = [
          {prop: 'order_number', label: '预报名订单号'},
          {prop: 'belong_teacher_name', label: '预报名客户归属人'},
          {prop: 'money_answer', label: '应缴金额'},
          {prop: 'money_actual', label: '实缴金额'},
          {prop: 'pay_time', label: '支付时间'}
        ]
        this.getStages().finally(() => {
          this.loading = false
        })
      }).catch(() => {
        this.loading = false
      })
    },
    onClick(formName, cache = true) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formData.is_pay === 2) return this.dialogVisible = true
          this.$refs[`t${this.formData.is_by_stages}`].submit().then(() => {
            const arr = this.formData.payment_detail.filter(i => i.paid_amount)
            const sum = arr.reduce((pre, cur) => preciseAdd(pre, Number(cur.paid_amount)), 0)
            let msg = ''
            const num1 = Number(this.sum_price)
            const num2 = Number(this.formData.sum_first_price)
            const num3 = Number(this.formData.show_price)

            if (this.formData.is_by_stages === 0) {
              if (num1 !== sum) {
                msg = `学生【实缴金额及方式】的累计实缴金额需等于【${this.interestAmount.isShow ? '学生合计应缴总额' : '合计实缴总额'}】`
              }
              // } else if ([1,2].includes(this.formData.is_by_stages)) {
              //   if (num2 !== sum) msg = '学生【实缴金额及方式】的累计实缴金额需等于【合计本期实缴总额】'
              //   if (this.formData.is_by_stages === 2 && num2 !== num3) msg = '学生【实缴金额及方式】的累计实缴金额需等于【本期实缴总额】'
            } else if ([1, 2].includes(this.formData.is_by_stages)) {
              const num4 = this.interestAmount.isShow ? this.interestAmount.sum : num2
              const num5 = Number(this.formData.sum_remain_price)
              if (num5 < 0) msg = '【本期实缴总额】需大于等于0且小于表单中的【实缴金额】'
              else if (this.formData.is_by_stages === 2 && num4 !== num3) msg = `学生【实缴金额及方式】的累计实缴金额需等于【本期实缴总额】`
              else if (num4 !== sum) msg = `学生【实缴金额及方式】的累计实缴金额需等于【${this.interestAmount.isShow ? '学生合计本期应缴总额' : '合计本期实缴总额'}】`
            }
            if (msg) return this.$message.error({message: msg, duration: 4000})
            if (cache) return this.dialogVisible = true
            this.onCm(false)
          }).catch(() => {
          })
        }
      });
    },
    onCm(cache) {
      const {is_pay, reason, remark, payment_detail, goods_stages, is_stages_dingtalk_approve, is_discount_dingtalk_approve, show_price, ...other} = this.formData;
      const id = this.$route.query.id
      const data = is_pay === 1 ? {id, is_pay, reason: remark, ...other} : {id, is_pay, reason}
      if (is_pay === 1) {
        data.payment_detail = this.showMethod ? payment_detail.map(item => {
          const {isAdd, id, payment_method, interest_amount, interest_rate_detail, ...other} = item
          const obj = {...other, payment_method}
          if (payment_method === '银行垫资') {
            obj.interest_amount = interest_amount
            obj.interest_rate_detail = interest_rate_detail
            obj.interest_rate = this.formData.interest_rate
            obj.interest_months = this.formData.interest_months
            obj.interest_amount_is_can_chg = this.formData.interest_amount_is_can_chg
          }
          return obj
        }) : [
          {
            payment_method: '现金',
            paid_amount: 0,
            payer: '/',
            payment_at: formatDate().fullDateTime
          }
        ]
        data.payment_at = data.payment_detail[0].payment_at
        data.goods_stages = goods_stages
        if (data.is_by_stages) {
          data.is_stages_dingtalk_approve = is_stages_dingtalk_approve
          // 分期 部分欠缴
          data.sum_first_price = this.sum_first_price
        }
        if (data.sum_discount_price) {
          data.is_discount_dingtalk_approve = is_discount_dingtalk_approve
        }
      }
      this.loading = true
      if (!cache) {
        return http({url: '/recruit-v2/order-offline/cache-v2', pre: 'zs', method: 'post'}, data).then(() => {
          this.$router.back()
        }).finally(() => {
          this.loading = false
        })
      }
      http({url: '/recruit-v2/order-offline/edit-v2', pre: 'zs', method: 'post'}, data).then(() => {
        this.$router.replace('/finance/enrollment/offline-payment-approval/look-2026?id=' + this.$route.query.id)
      }).finally(() => {
        this.loading = false
      })
    },
    handleClose() {
      this.dialogVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.tips-info {
  margin-top: 10rem;
  padding: 0 10rem;
  background-color: #f4f4f5;
  color: #909399;
  font-size: 12rem;
  line-height: 30rem;
  display: inline-block;
  border-radius: 6rem;

  .z-i {
    margin-right: 4rem;
  }

  &.warning {
    color: #F25858;
    background-color: #FFEAEA;
  }
}

.table-wrap {
  padding: 30rem 0;
  margin: 10rem 0 30rem;
  border-top: dashed 1rem #598BFF;
  border-bottom: dashed 1rem #598BFF;
}

::v-deep(.el-transfer-panel) {
  width: 440rem;
}
</style>
